import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { 
    ObjToKeysPipe,
    SafeHtmlPipe,
    OrderByPipe,
    KendoFilterValuesPipe
} from '../all-pipes'



@NgModule({
  declarations:[
    ObjToKeysPipe,
    SafeHtmlPipe,
    OrderByPipe,
    KendoFilterValuesPipe
  ]
  ,exports:[
    ObjToKeysPipe,
    SafeHtmlPipe,
    OrderByPipe,
    KendoFilterValuesPipe
  ]
})
export class PafAllPipesModule{}
